import { IPaymentRequisitionState } from '@/store/payment-requisition';
import { IPaymentRequisitionMutations } from './mutations.types';
import {
  IUserData,
  IPaymentRequisitionData,
  IPaymentRequisitionCommentData,
  IPaymentRequisitionLineData
} from '@/models';
import { Transition } from '@/models/transition';

export const mutations: IPaymentRequisitionMutations = {
  SET_COUNT(state: IPaymentRequisitionState, payload: number): void {
    state.count = payload;
  },

  INCREMENT_COUNT(state: IPaymentRequisitionState): void {
    state.count += 1;
  },

  DECREMENT_COUNT(state: IPaymentRequisitionState): void {
    state.count -= 1;
  },

  SET_PAYMENT_REQUISITIONS(
    state: IPaymentRequisitionState,
    payload: IPaymentRequisitionData[]
  ): void {
    state.paymentRequisitions = payload;
  },

  ADD_PAYMENT_REQUISITION(
    state: IPaymentRequisitionState,
    payload: IPaymentRequisitionData
  ): void {
    state.paymentRequisitions.unshift(payload);
  },

  UPDATE_PAYMENT_REQUISITION(
    state: IPaymentRequisitionState,
    payload: IPaymentRequisitionData
  ): void {
    const index = state.paymentRequisitions.findIndex(
      (paymentRequisition: IPaymentRequisitionData) =>
        paymentRequisition.id === payload.id
    );

    state.paymentRequisitions.splice(index, 1, payload);
  },

  REMOVE_PAYMENT_REQUISITION(
    state: IPaymentRequisitionState,
    payload: number
  ): void {
    const index = state.paymentRequisitions.findIndex(
      (paymentRequisition: IPaymentRequisitionData) =>
        paymentRequisition.id === payload
    );

    state.paymentRequisitions.splice(index, 1);
  },

  UPDATE_PAYMENT_REQUISITION_LINE(
    state: IPaymentRequisitionState,
    payload: { id: number; line: IPaymentRequisitionLineData }
  ): void {
    const requisitionIndex = state.paymentRequisitions.findIndex(
      (requisition: IPaymentRequisitionData) => requisition.id === payload.id
    );

    const requisition = state.paymentRequisitions[requisitionIndex];

    const requisitionLineIndex = requisition.lines!.findIndex(
      line => line.id === payload.line.id
    );

    requisition.lines!.splice(requisitionLineIndex, 1, payload.line);
  },

  SET_LAST_CREATED_PAYMENT_REQUISITION_ID(
    state: IPaymentRequisitionState,
    payload: number
  ): void {
    state.lastCreatedPaymentRequisitionId = payload;
  },

  SET_PAYMENT_REQUISITION_APPROVERS(
    state: IPaymentRequisitionState,
    payload: IUserData[]
  ): void {
    state.approvers = payload;
  },

  SET_PAYMENT_REQUISITION_AP_SPECIALISTS(
    state: IPaymentRequisitionState,
    payload: IUserData[]
  ): void {
    state.apSpecialists = payload;
  },

  SET_PAYMENT_REQUISITION_ACTIVITIES(
    state: IPaymentRequisitionState,
    payload: Transition[]
  ): void {
    state.activities = payload;
  },

  SET_PAYMENT_REQUISITION_COMMENTS(
    state: IPaymentRequisitionState,
    payload: IPaymentRequisitionCommentData[]
  ): void {
    state.comments = payload;
  },

  ADD_PAYMENT_REQUISITION_COMMENT(
    state: IPaymentRequisitionState,
    payload: IPaymentRequisitionCommentData
  ): void {
    state.comments.unshift(payload);
  },

  UPDATE_PAYMENT_REQUISITION_COMMENT(
    state: IPaymentRequisitionState,
    payload: IPaymentRequisitionCommentData
  ): void {
    const index = state.comments.findIndex(
      (comment: IPaymentRequisitionCommentData) => comment.id === payload.id
    );

    state.comments.splice(index, 1, payload);
  },

  REMOVE_PAYMENT_REQUISITION_COMMENT(
    state: IPaymentRequisitionState,
    payload: number
  ): void {
    const index = state.comments.findIndex(
      (comment: IPaymentRequisitionCommentData) => comment.id === payload
    );

    state.comments.splice(index, 1);
  },

  SET_LAST_CREATED_PAYMENT_REQUISITION_COMMENT_ID(
    state: IPaymentRequisitionState,
    payload: number
  ): void {
    state.lastCreatedPaymentRequisitionCommentId = payload;
  },

  SET_MENTIONABLE_USERS(
    state: IPaymentRequisitionState,
    payload: IUserData[]
  ): void {
    state.mentionableUsers = payload;
  },

  SET_LAST_PROMISE(
    state: IPaymentRequisitionState,
    payload: Promise<any>
  ): void {
    state.lastPromise = payload;
  }
};
